export default __webpack_public_path__ + "static/construction-of-knowledge-in-science-8b749e7996911920b6976593c62b9fe1.pdf";